/**
 * Created by nguyendx 2017/09/28.
 */
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class EvsAuthenticationService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
    this.setEndPoint('/v2/login');
  }

  loginEvs(data: any) {
    let mData: any;
    let tokenExpired: number;
    tokenExpired = 24 * 60 * 60 * 1000; // 24*60*60*1000 == 24h
    mData = {
      username: data.username,
      password: data.password,
      ttl_in_second: tokenExpired,
    };
    return this.login('/v2/login', mData);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/EvsAuthentication.service.ts